import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { db, auth } from '../firebase';
import { doc, updateDoc, arrayUnion } from 'firebase/firestore';

export const messagingService = {
  async requestPermission() {
    try {
      const messaging = getMessaging();
      const permission = await Notification.requestPermission();

      if (permission === 'granted') {
        const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;
        if (!vapidKey || vapidKey === 'BM0uHh79W99C8YV-H-5hV-vE8R-E_Cq-e_L_Q_S_W_E_R_T_Y_U_I_O_P') {
          console.warn(
            'Web Push VAPID key is missing or is using a placeholder. Skipping token registration.'
          );
          return;
        }

        const token = await getToken(messaging, { vapidKey });

        if (token) {
          await this.saveTokenToUser(token);
        }
      }
    } catch (error) {
      console.error('Error requesting notification permission:', error);
    }
  },

  async saveTokenToUser(token: string) {
    const user = auth.currentUser;
    if (!user) return;

    try {
      const userRef = doc(db, 'users', user.uid);
      await updateDoc(userRef, {
        fcmTokens: arrayUnion(token),
      });
    } catch (error) {
      console.error('Error saving FCM token to user profile:', error);
    }
  },

  onMessageListener() {
    const messaging = getMessaging();
    return new Promise((resolve) => {
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    });
  },
};
